// - fx/effects/applyStyle.js
/**
 * Create a callback for FXEngine that applies a single CSS property
 * based on progress t ∈ [0, 1].
 *
 * @param {string} property - CSS property to modify (e.g. "opacity", "transform").
 * @param {object} options
 *    - reverse (bool): invert progress for convenience
 *    - unit (string): optional unit for numeric values ("%", "px", etc.)
 *    - transformer (fn): optional function receiving t and returning a computed value
 *
 * @returns (el, t, rect) => void
 */
export function applyStyle(property, {
    reverse = false,
    unit = "",
    transformer = null
} = {}) {

    return function(el, progress, rect) {

        const t = reverse ? (1 - progress) : progress;

        // - If the user defines a transformer, use it.
        // - It must return a final string or number.
        if (typeof transformer === "function") {
            const value = transformer(t, el, rect);
            el.style[property] = value;
            return;
        }

        // - Default: apply numeric value directly
        const value = `${t}${unit}`;
        el.style[property] = value;

    };

}